export default __webpack_public_path__ + "static/subic-grain-b327d72f0fc815cd63f5797f6c2c94a2.png";